"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = void 0;
const copyToClipboard = ({ target, message, value }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let copyValue = "";
        if (!navigator.clipboard) {
            throw new Error("Browser don't have support for native clipboard.");
        }
        if (target) {
            const node = document.querySelector(target);
            if (!node || !node.textContent) {
                throw new Error("Element not found");
            }
            value = node.textContent;
        }
        if (value) {
            copyValue = value;
        }
        yield navigator.clipboard.writeText(copyValue);
        return true;
    }
    catch (error) {
        console.error(error.toString());
        return false;
    }
});
exports.copyToClipboard = copyToClipboard;
